import { Card } from '@app/components/various/Card';
import { useTableColumnsConfiguration } from '@app/utils/hooks/table/useTableColumnsConfiguration';

export const AccountRequestsListCardSkeleton = () => {
  const { columnsVisibility } = useTableColumnsConfiguration({ tableName: 'accountRequests' });
  const visibleAttributesCount = [
    columnsVisibility.company?.isVisible,
    columnsVisibility.createdAt?.isVisible,
    columnsVisibility.email?.isVisible,
    columnsVisibility.source?.isVisible,
    columnsVisibility.status?.isVisible,
    columnsVisibility.name?.isVisible,
  ].filter(Boolean).length;

  const visibleSummaryAttributesCount = [columnsVisibility.buyer?.isVisible, columnsVisibility.total?.isVisible].filter(Boolean).length;

  return (
    <Card.Wrapper>
      {columnsVisibility.status?.isVisible && <Card.Header isLoading />}
      <Card.Title isLoading />
      <Card.AttributeList className="flex-1" isLoading skeletonRows={visibleAttributesCount} />
      <Card.SummaryList isLoading skeletonRows={visibleSummaryAttributesCount} />
    </Card.Wrapper>
  );
};
